import React from "react";
import { Col, Row, Form, Modal, Select, Radio, Spin, InputNumber, Tag, Space } from "antd";
import { URL_SALE, URL_SKIM } from "../../constants/urls";
import { GET, POST } from "../../frameworks/HttpClient";
import _, { rearg } from "lodash";
import ErrorMessages from "../../common/ErrorMessages";
import { TANK_STATUS } from "../../constants/string";
import ColorButton from "../../common/ColorButton";
import { PRIMARY_COLOR } from "../../constants/color";

export default function LoadSkimModal(props) {
  const { open, onClose, target, onUpdate, saleOrder } = props;
  const [errorMessages, setErrorMessages] = React.useState(null)
  const [debouncedLot, setDebouncedLot] = React.useState(null);
  const [fetching, setFetching] = React.useState(null);
  const [lotOptions, setLotOptions] = React.useState(null);

  const [form] = Form.useForm();
  const amountWatch = Form.useWatch('amount', form);
  const [weightPerPiece, setWeightPerPiece] = React.useState(0);
  const isSelfOrder = Form.useWatch("self_order", form);

  const debounceLot = React.useCallback(_.debounce((_searchVal) => { setDebouncedLot(_searchVal) }, 800), []);

  const fetchLotSkim = async () => {
    setFetching(true);
    try {
      const response = await GET(`${URL_SKIM.SKIM_STOCK}`, { sale_order : isSelfOrder ? saleOrder.id : '', stock_no : debouncedLot, is_closed : false })
      setLotOptions(response.data.results.map((item) => {
        return {
          ...item,
          label: `${item.stock_no} [${item.product_name} (${item.product_short_name})] : ${item.current} ก้อน`,
          value: item.id
        }
      }))
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setFetching(false);
    }
  }

  const handleOK = async () => {
    setErrorMessages(null)
    try {
      const data = await form.validateFields();
      data['delivery_order'] = target.id
      await POST(URL_SALE.LOAD_SKIM_STOCK, data);
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  };

  React.useEffect(() => {
    if(open)
      fetchLotSkim();
  },[debouncedLot])

  React.useEffect(() => {
    if(isSelfOrder != null){
      fetchLotSkim();
    }
  },[isSelfOrder])

  React.useEffect(() => {
    setErrorMessages(null)
    if(open){
      fetchLotSkim();
      form.setFieldValue('self_order', true)
    } else {
      setWeightPerPiece(0)
      form.resetFields()
    }
  },[open])

  return(
    <Modal
      open={open}
      onCancel={() => {
        form.resetFields()
        onClose()
      }}
      cancelText={"ยกเลิก"}
      okText={"โหลด"}
      title={"โหลดสกิม (พาเลท)"}
      width={700}
      onOk={handleOK}
      centered
      destroyOnClose
      footer={[
        <>
          <div style={{ textAlign: 'left' }}>
            <Space>
              <div style={{ margin: 10, width: 300}}>
                {`น้ำหนักประมาณ(kg) :  `} <Tag color="blue">{ weightPerPiece && amountWatch ? Number(weightPerPiece * amountWatch).toFixed(2) : 0}</Tag>
              </div>
              <div style={{ textAlign: 'right', width: 350}}>
                <ColorButton onClick={onClose}>ปิด</ColorButton>
                <ColorButton type='primary' onClick={handleOK} style={{ marginLeft : 10}} override={PRIMARY_COLOR}>โหลด</ColorButton>
              </div>
            </Space>
          </div>  
        </>
      ]}
    >
    <ErrorMessages message={errorMessages}/>
    <Form
      form={form}
      layout="horizontal"
      style={{ marginBottom: 40 }}
    >
      <Row gutter={10}>
        <Col>
          <Form.Item
            label="การเลือกพาเลท: "
            name="self_order"
            rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
          >
            <Radio.Group 
              onChange={async(e) => {
                form.setFieldValue('tank_transaction', null)
              }}
            >
              <Radio value={true}>ตามใบแจ้งผลิต</Radio>
              <Radio value={false}>พาเลททั้งหมด</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
        <Col span={15}>
          <Form.Item
            label="เลขที่พาเลท"
            name="stock"
            layout="vertical"
            rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
          >
          <Select 
            initialvalues={"-"}
            autoComplete="off" 
            showSearch
            filterOption={false}
            notFoundContent={fetching ? <Spin size="small" /> : "-"}
            onSearch={debounceLot}
            options={lotOptions}
            onSelect={(e, option) => setWeightPerPiece(option.weight_per_piece)}
            onClear={() => setWeightPerPiece(0)}
            allowClear={"-"}/>
          </Form.Item>
        </Col>
        <Col span={9}>
          <Form.Item
            label="ปริมาณโหลด(ก้อน)"
            name="amount"
            layout="vertical"
            rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
          >
            <InputNumber placeholder="ปริมาณโหลด(ก้อน)" style={{ width : '100%'}}/>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  </Modal>)
}